import type { Request } from '../../../shared/api/types'
import { isCrmCoreRole } from '@crm/shared'
import { ActionsPanel } from './ActionsPanel'
import { CommentsPanel } from './CommentsPanel'

// Блок КП вынесен отдельным full-width аккордеоном — см. KPAccordion.
// Здесь остаются только «Действия» и «Комментарии» в один ряд.

type Props = {
  request: Request
  userRole: string | undefined
}

export function RequestBottomPanel({ request, userRole }: Props) {
  return (
    <div className="flex flex-col lg:flex-row gap-4 items-start">
      {/* Белый список: нынешние роли, кроме рядового закупщика (23.09.2026). */}
      {isCrmCoreRole(userRole ?? '') && userRole !== 'PROCUREMENT' && (
        <div className="bg-white rounded-xl border border-gray-200 p-4 w-full lg:w-72 shrink-0">
          <h2 className="text-sm font-medium text-gray-700 mb-3">Действия</h2>
          <ActionsPanel
            requestId={request.id}
            status={request.status}
            sellerEntityId={request.sellerEntityId}
            items={request.items ?? []}
          />
        </div>
      )}

      <div className="bg-white rounded-xl border border-gray-200 p-4 flex-1 min-w-0">
        <h2 className="text-sm font-medium text-gray-700 mb-3">Комментарии</h2>
        <CommentsPanel
          requestId={request.id}
          filterForProcurement={userRole === 'PROCUREMENT'}
          requestManagerId={request.managerId}
        />
      </div>
    </div>
  )
}
